type ApiPaths = {
  dashboardGatewayBasePath: string;
  networkTokensApiBasePath: string;
  notificationsApiBasePath: string;
  notificationsWssBasePath: string;
  prismApiBasePath: string;
  prismInsightsApiBasePath: string;
  processingChannelsApiBasePath: string;
  segmentsApiBasePath: string;
  userManagementApiBasePath: string;
};

const APP_BFF_API_PATH = `${window.__app_config.WEBUI_ROUTING_BASE_PATH}/api`;

export const API_PATHS: ApiPaths = {
  dashboardGatewayBasePath: window.__app_config.WEBUI_DASHBOARD_GATEWAY_BASE_URL,
  networkTokensApiBasePath: window.__app_config.WEBUI_NETWORK_TOKENS_API_BASE_URL,
  notificationsApiBasePath: `${window.__app_config.WEBUI_DASHBOARD_GATEWAY_BASE_URL}/notifications`,
  notificationsWssBasePath: window.__app_config.WEBUI_NOTIFICATIONS_WSS_BASE_URL,
  prismApiBasePath: window.__app_config.WEBUI_PRISM_API_BASE_URL,
  prismInsightsApiBasePath: window.__app_config.WEBUI_INSIGHTS_API_BASE_URL,
  processingChannelsApiBasePath: `${APP_BFF_API_PATH}/processing-channels`,
  segmentsApiBasePath: window.__app_config.WEBUI_SEGMENTS_API_BASE_URL,
  userManagementApiBasePath: window.__app_config.WEBUI_USER_MANAGEMENT_API_BASE_URL,
};
